import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";
import { Chip, Image, Radio } from "@nextui-org/react";

import { AvatarPreset } from "@/types";
import { getAvatarUrl } from "@/utils";

import { Col, Row, Text } from "../../customComponents";
import { PersonaCardProps } from "./types";

export default function PersonaCard(props: PersonaCardProps) {
  const { data, setSelectedAvatar, setSelectedPersonaIds, isMobile, defaultPersonaId } = props;
  const { id, avatar_url, name, highlights } = data;

  const handlePersonaChange = () => {
    setSelectedPersonaIds?.([id]);
    setSelectedAvatar?.(avatar_url);
  };

  const DefaultLabel = () => {
    return (
      <Chip size="sm" classNames={{ base: "bg-gray-800", content: "*:text-white *:dark:text-black" }}>
        <Text variant={"md"} type={"medium"} mNone={undefined}>
          Default
        </Text>
      </Chip>
    );
  };

  return (
    <Radio
      value={`${id}`}
      classNames={{ base: "items-start w-full max-w-[460px] ", labelWrapper: "grow", wrapper: "relative top-2" }}
      onChange={handlePersonaChange}
    >
      <Row className={"p-3 group-data-[selected=true]:bg-gray-100 group-data-[selected=true]:bg-opacity-30 grow"} gap={1} style={undefined}>
        <Col className="w-min">
          {avatar_url ? (
            <Image
              src={getAvatarUrl(avatar_url, { preset: AvatarPreset.AVATAR_128X128 }) as string}
              alt={name}
              loading="lazy"
              height={isMobile ? 80 : 100}
              width={isMobile ? 80 : 100}
              radius="sm"
              className="object-cover opacity-100"
            />
          ) : (
            <div
              className={
                "bg-zinc-300 text-gray-600 flex justify-center items-center rounded-lg " + (isMobile ? "h-[80px] w-[80px]" : "h-[100px] w-[100px]")
              }
            >
              <Icon icon={IconVariants.USER} size={IconSize.XLARGE} />
            </div>
          )}
        </Col>
        <Col gap={0.5}>
          <Row style={undefined} className="flex-wrap gap-2">
            <Text b variant={"regular"} type={undefined} mNone={undefined}>
              {name}
            </Text>
            {defaultPersonaId === id && <DefaultLabel />}
          </Row>
          <Text i variant={"regular"} type={"gray-800 [overflow-wrap:anywhere] line-clamp-3"} mNone={undefined}>
            {highlights}
          </Text>
        </Col>
      </Row>
    </Radio>
  );
}
